<!-- 多维度运输数据智能统计 -->
<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList } from "./api";
import { getSearchTimeConfig } from "@/basic-common/util/common";
import { getMonthStartTime, getTodayEndTime } from "@/util/date.js";
export default {
  name: "MultiTransportData",
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList },
      defaultParams: { stockType: 0 },
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menu: true,
        column: [
          {
            label: "客户",
            prop: "custNo",
            search: true,
            type: "select",
            remote: true,
            // hide: true,
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            props: {
              label: 'deptName',
              value: 'id'
            },
            overHidden: true,
          },
          {
            label: "物资名称",
            prop: "cargoNo",
            search: true,
            type: "select",
            remote: true,
            // hide: true,
            dicUrl: "/api/produce/vardict/select/distinct/pycode?varName={{key}}",
            props: { label: "varName", value: "varNo" },
            overHidden: true,
          },
          { label: "日期", prop: "dt", width: 110 },
          { label: "出库量(吨)", prop: "outWeight" },
          { label: "入库量(吨)", prop: "inWeight" },
          { label: "运输总量(吨)", prop: "totalShipWeight" },
          {
            ...getSearchTimeConfig(),
            paramsKey: ["startTime", "endTime"],
            // searchValue: [getMonthStartTime(), getTodayEndTime()],
          },
        ],
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
::deep(.el-table__header-wrapper th) {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}
</style>
